module.exports = __webpack_public_path__ + "static/media/map-bg.c8640ef0.png";